// extracted by mini-css-extract-plugin
export default {"faqAnswerImg":"FaqAnswerImg_faqAnswerImg__aUKTG"};